export const COMMITTEES_FETCH_REQUESTED = 'COMMITTEES_FETCH_REQUESTED'
export const COMMITTEES_FETCH_SUCCESS = 'COMMITTEES_FETCH_SUCCESS'
export const COMMITTEES_FETCH_FAILED = 'COMMITTEES_FETCH_FAILED'

export const COMMITTEE_MEMBERS_FETCH_REQUESTED =
  'COMMITTEE_MEMBERS_FETCH_REQUESTED'
export const COMMITTEE_MEMBERS_FETCH_SUCCESS = 'COMMITTEE_MEMBERS_FETCH_SUCCESS'
export const COMMITTEE_MEMBERS_FETCH_FAILED = 'COMMITTEE_MEMBERS_FETCH_FAILED'

export const COMMITTEE_UPDATE_RESPONSIBILITY_REQUESTED =
  'COMMITTEE_UPDATE_RESPONSIBILITY_REQUESTED'
export const COMMITTEE_UPDATE_RESPONSIBILITY_SUCCESS =
  'COMMITTEE_UPDATE_RESPONSIBILITY_SUCCESS'
export const COMMITTEE_UPDATE_RESPONSIBILITY_FAILED =
  'COMMITTEE_UPDATE_RESPONSIBILITY_FAILED'

export const COMMITTEES_RESET = 'COMMITTEES_RESET'
export const COMMITTEES_PROCESSING_RESET = 'COMMITTEES_PROCESSING_RESET'
